import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FormUrlParam, HFWSScriptSrc, WebSectionId } from '@customTypes/enums';
import type { HeadProps } from '@customTypes/types';

export const Head = (props: HeadProps): JSX.Element => {
  const [webSectionId, setWebSectionId] = useState<string>();
  const [hfwsSrc, setHfwsSrc] = useState<string>();

  useEffect(() => {
    props.searchUrlParam && setDynamicHeadValues(props.searchUrlParam);
  }, [props.searchUrlParam]);

  const setDynamicHeadValues = (searchUrlParam) => {
    switch (searchUrlParam) {
      case FormUrlParam.BlankRequest:
      case FormUrlParam.ComputeSupport:
      case FormUrlParam.Denali:
      case FormUrlParam.DeveloperPortal:
      case FormUrlParam.DSSupport:
      case FormUrlParam.GLCentral:
      case FormUrlParam.GLSupport:
      case FormUrlParam.GlobalTrade:
      case FormUrlParam.GlobalTrade_old:
      case FormUrlParam.GreenLakeSupport:
      case FormUrlParam.GreenLakeSupportTest:
      case FormUrlParam.LoginSupport_GLCP:
      case FormUrlParam.Marketplace:
      case FormUrlParam.OpsRamp:
      case FormUrlParam.ManagedCloudService:
      case FormUrlParam.NetworkingArubaCentral:
      case FormUrlParam.DashboardsAndMonitoring:
      case FormUrlParam.SupportHub:
      case FormUrlParam.OSQBM:
      case FormUrlParam.PrivateCloud:
      case FormUrlParam.RPL_SupportCenter_GLCP:
      case FormUrlParam.RPL_SupportCenter_GLCP_old:
      case FormUrlParam.SWD_SupportCenter_GLCP:
        setWebSectionId(WebSectionId.R11852);
        setHfwsSrc(HFWSScriptSrc.GLCPLogoBasicFooter);
        break;
      case FormUrlParam.GlobalTrade_SupportCenter:
      case FormUrlParam.GlobalTrade_SupportCenter_old:
      case FormUrlParam.RPL_SupportCenter:
      case FormUrlParam.RPL_SupportCenter_old:
      case FormUrlParam.SWD_SupportCenter:
        setWebSectionId(WebSectionId.R11554);
        setHfwsSrc(HFWSScriptSrc.HPELogoBasicFooter);
        break;
      case FormUrlParam.LoginSupport:
      case FormUrlParam.LoginSupport_ML:
        setWebSectionId(WebSectionId.R11554);
        setHfwsSrc(HFWSScriptSrc.HPELogoDetailedFooter);
        break;
    }
  };

  return (
    <Helmet>
      <meta name="web_section_id" content={webSectionId} />
      <script src={'https://h50007.www5.hpe.com/hfws/us/en/hpe/latest.r/root?contentType=js&switchToCHF=true&hide_country_selector=true&console_mode=true&hide_main_nav=true&hide_search=true&hide_cart=true&hide_sign_in=true&hide_help_menu=true&hide_cube_menu=true' + hfwsSrc}></script>
    </Helmet>
  );
};
